import { useDisclosure } from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';
import { Modal } from '../modal';
import { useIsMobile } from '../../hooks';

import { DonorConfirmThanked } from './DonorConfirmThanked';

export interface DonorSayThanksModalProps {
  donorName: string;
  isOpen: boolean;
  onClosed: () => void;
  onAlreadyThanked: () => void;
  onSendThankyou: () => void;
}

export const DonorSayThanksModal: FC<DonorSayThanksModalProps> = (
  props
): JSX.Element => {
  const { onAlreadyThanked, onSendThankyou, onClosed, donorName, isOpen } =
    props;
  const { onClose } = useDisclosure();
  const isMobile = useIsMobile();
  const [internalIsOpen, setInternalIsOpen] = useState(isOpen);

  const close = () => {
    setInternalIsOpen(false);
    onClose();
    onClosed();
  };

  useEffect(() => {
    setInternalIsOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal
      isOpen={internalIsOpen}
      onClose={close}
      size={isMobile ? 'sm' : 'lg'}
    >
      <DonorConfirmThanked
        donorName={donorName}
        onAlreadyThanked={() => {
          setInternalIsOpen(false);
          onClose();
          onAlreadyThanked();
        }}
        onSendThankyou={() => {
          setInternalIsOpen(false);
          onClose();
          onSendThankyou();
        }}
      />
    </Modal>
  );
};
